export default __webpack_public_path__ + "static/media/S60.d9259de5.png";